import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from './translate/translate.pipe';
import { GetJsonValuePipe } from './getJsonValue/get-json-value.pipe';
import { FormatTimePipe } from './format-time/format-time.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TranslatePipe,
    GetJsonValuePipe,
    FormatTimePipe

  ],
  exports: [
    TranslatePipe,
    GetJsonValuePipe,
    FormatTimePipe
    
  ],
  providers: [
    GetJsonValuePipe,
    TranslatePipe,
  ]
})
export class PipesModule { }
